import { createFileRoute } from '@tanstack/react-router'
import { GlossaryPage, glossaryHead } from '@/components/glossary-page'

const data = {
  term: 'MTTR (Mean Time To Repair)',
  slug: 'mttr',
  definition: `MTTR measures the average time it takes to repair a system after a failure. It starts when the failure is detected and ends when the service is fully restored. MTTR is one of the four key incident metrics used in reliability engineering.

MTTR includes diagnosis time, fix implementation, testing, and deployment. A team with an MTTR of 30 minutes resolves most incidents within half an hour of learning about them. Lower MTTR means less total downtime and happier users.

MTTR is sometimes also used to mean Mean Time To Recovery or Mean Time To Respond, depending on the organization. The core idea is the same: how quickly can you get back to normal after something breaks?`,
  whyItMatters: `MTTR is the metric you have the most control over. You cannot always prevent failures, but you can always improve how fast you recover. Teams that invest in reducing MTTR see outsized improvements in overall availability.

A low MTTR also reduces the blast radius of incidents. If you can fix problems in minutes instead of hours, each incident has far less impact on users and revenue.`,
  howUptrackHelps: `Uptrack records the exact start and end time of every incident, automatically calculating your MTTR. You can track this metric over time to see whether your team is improving.

Fast detection is the first step to fast repair. With 30-second checks, Uptrack ensures the detection phase of MTTR is as short as possible, giving your team more time for the actual fix.`,
  formula: 'MTTR = Total Repair Time / Number of Repairs',
  relatedTerms: [
    { name: 'MTTD', href: '/glossary/mttd' },
    { name: 'MTTF', href: '/glossary/mttf' },
    { name: 'MTBF', href: '/glossary/mtbf' },
    { name: 'Incident Management', href: '/glossary/incident-management' },
    { name: 'MTBF guide: meaning, formula, examples', href: '/blog/what-is-mtbf-meaning-formula' },
  ],
}

export const Route = createFileRoute('/_site/glossary/mttr')({
  component: () => <GlossaryPage data={data} />,
  head: () => glossaryHead(data),
})
